/**
 * All defined banners in priority order.
 *
 * In code, a banner is this structure
 *
 * {
 *   // For now, this ID correlates to an HTML template in preview-banner.component.html.
 *   // At some point, we'd like to completely decouple the banner from the directive itself, with the ultimate
 *   // goal of being able to manage banners separately from the insight dashboard release cycle.
 *   id: <Angular template ID>,
 *   cssClass: <CSS class applied to the banner container>,
 *
 *   // Optional map of user types this banner applies to
 *   // If not specified banner is available to all user types
 *   restrictTo: {
 *     guardian: 'guardian',
 *     teacher: 'teacher',
 *     admin: 'admin'
 *   },
 *
 *   enabled: true|false, // this can also be a function(customer) -> true|false
 *
 *   // Optional init function called when banner is displayed
 *   init: function(customer){},
 *
 *   // Optional start date
 *   // Banner will not display before start date/time (based on browser clock)
 *   startDate: {Date|'YYYY-MM-DDTHH:mm:SS'}
 *
 *   // Optional end date
 *   // Banner will not display after end date/time (based on browser clock)
 *   endDate: {Date|'YYYY-MM-DDTHH:mm:SS'}
 * }
 */
angular.module('previewBannerModule').value('edxPreviewBanners', [
  {
    id: 'preview-banner-test.html',
    cssClass: 'test-banner',
    restrictTo: {
      teacher: 'teacher',
      admin: 'admin'
    },
    enabled: false
  },
  {
    id: 'graduation-kit.html',
    cssClass: 'graduation-kit',
    restrictTo: {
      teacher: 'teacher',
      admin: 'admin'
    },
    enabled: false,
    startDate: '2019-04-09T00:00:00',
    endDate: '2019-06-30T00:00:00'
  },
  {
    id: 'bts-2019.html',
    cssClass: 'bts-2019',
    restrictTo: {
      teacher: 'teacher',
      admin: 'admin'
    },
    enabled: true,
    startDate: '2019-06-25T00:00:00',
    endDate: '2019-10-15T00:00:00'
  },
  {
    id: 'seasonal-fun-fall.html',
    cssClass: 'seasonal-fun-fall',
    restrictTo: {
      teacher: 'teacher',
      admin: 'admin'
    },
    enabled: true,
    startDate: '2019-10-24T00:00:00',
    endDate: '2019-11-30T00:00:00'
  },
  {
    id: 'all-state-standards.html',
    cssClass: 'all-state-standards',
    restrictTo: {
      teacher: 'teacher',
      admin: 'admin'
    },
    enabled: true,
    startDate: '2020-01-07T00:00:00',
    endDate: '2020-02-01T00:00:00'
  },
  {
    id: 'subscribe-after-free-trial.html',
    cssClass: 'subscribe-after-trial',
    restrictTo: {
      guardian: 'guardian',
    },
    enabled: true,
    startDate: '2020-06-09T00:00:00',
    endDate: '2020-07-31T00:00:00'
  },
  {
    id: 'new-dashboard-experience.html',
    cssClass: 'new-dashboard-experience',
    restrictTo: {
      teacher: 'teacher',
      admin: 'admin',
    },
    enabled: true,
    startDate: '2020-07-30T00:00:00',
    endDate: '2020-08-23T00:00:00'
  },
  {
    id: 'k-2-graduation.html',
    cssClass: 'k-2-graduation',
    restrictTo: {
      teacher: 'teacher',
      admin: 'admin',
    },
    enabled: true,
    startDate: '2020-08-23T00:00:00',
    endDate: '2020-08-30T00:00:00'
  },
  {
    id: 'teacher-student-messaging.html',
    cssClass: 'teacher-student-messaging',
    restrictTo: {
      teacher: 'teacher',
    },
    enabled: true,
    startDate: '2020-10-08T00:00:00',
    endDate: '2020-11-15T00:00:00'
  },
]);
